import { textSm } from '@insify/design-system/typography';
import clsx from 'clsx';

import styles from './styles.module.css';

const Container = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.container}>{children}</div>;
};

const Row = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.row}>{children}</div>;
};

const Label = ({ children }: { children: React.ReactNode }) => {
  return <p className={styles.label}>{children}</p>;
};

const Text = ({ children, subText }: { children: React.ReactNode; subText?: string }) => {
  return (
    <div className={styles.text}>
      <p>{children}</p>
      {subText && <p className={clsx(styles.subText, textSm)}>{subText}</p>}
    </div>
  );
};

export const InfoDisplay = {
  Container,
  Row,
  Label,
  Text,
};
